export default __webpack_public_path__ + "static/media/Full_stack_developer-1-1.86d1401a.jpg";